<template>
    <div name="soldoc-use" class="use">
        <div class="box">
            <div class="text-box" v-if="currentSlide == 0">
                <span class="title">비대면 진료<br/>예약하기</span>
            </div>
            <div class="text-box" v-if="currentSlide == 1">
                <span class="title">처방약은 대기 없이<br>간편하게 픽업</span>
            </div>
            <div class="text-box" v-if="currentSlide == 2">
                <span class="title">진료 서류는<br>모바일에서 확인</span>
            </div>
            <div style="padding-right:20px;">
                <img style="width: 32px" @click="prevSlide" src="../assets/left.png" />
                <img style="width: 32px" @click="nextSlide" src="../assets/right.png" />
            </div>
        </div>
        <div class="slider-container">
            <div class="slider-wrapper" :style="{ 'transform': `translateX(-${currentSlide * 100}%)` }">
                <div class="slide" v-for="(slide, index) in slides" :key="index">
                    <!-- 여기에 각 슬라이드의 내용을 넣습니다 -->
                    <img class="image" v-if="slide == 1" src="../assets/booking.gif" :alt="'Slide ' + (index + 1)">
                    <img class="image" v-if="slide == 2" src="../assets/receive.gif" :alt="'Slide ' + (index + 1)">
                    <img class="image" v-if="slide == 3" src="../assets/download.gif" :alt="'Slide ' + (index + 1)">
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'soldocUse',
    data: function()
    {
        return {
            currentSlide: 0,
            slides: [1, 2, 3]
        }

    },
    mounted: function()
    {
        setInterval(this.nextSlide, 7000);
    },
    methods: {
        nextSlide() {
            if (this.currentSlide < this.slides.length - 1) {
            this.currentSlide++;
            } else {
            this.currentSlide = 0;
            }
        },
        prevSlide() {
            if (this.currentSlide > 0) {
            this.currentSlide--;
            } else {
            this.currentSlide = this.slides.length - 1;
            }
        }
    }
}
</script>

<style scoped>
    .use {
        width: 100%;
        background: #FFFFFF;
        padding-top: 40px;
        padding-bottom: 99px;
    }

    .slider-container {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin-top: 34px;
    }
    
    .slider-wrapper {
        display: flex;
        transition: transform 0.3s ease-out;
    }
    
    .slide {
        min-width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .nav-buttons {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    
    .nav-button {
        background: none;
        border: none;
        cursor: pointer;
    }
    .image {
        width: calc(100% - 70px);
    }
    .title {
        color: #000;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 126.667% */
    }
    .sub-title {
        color: #666;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 137.5% */
        margin-top: 19px;
    }

    .text-box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-left: 20px;
    }
    .box {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }   
</style>


// WEBPACK FOOTER //
// src/components/SoldocUse.vue